const openpgp = require('openpgp');

/**
 * OpenPGP Encryption Service
 * Uses OpenPGP v4 for compatibility with webpack
 */
class OpenPGPService {
  constructor() {
    this.password = process.env.REACT_APP_ENCRYPTION_KEY;
    
    // Configure OpenPGP
    if (typeof window !== 'undefined') {
      openpgp.config.aeadProtect = false; // Disable AEAD for compatibility
      openpgp.config.preferHashAlgorithm = 8; // SHA256
      openpgp.config.encryptionCipher = 9; // AES256
    }
  }

  /**
   * Encrypts password using OpenPGP
   * @param {string} plainText - Password to encrypt
   * @returns {Promise<string>} Hex-encoded encrypted password
   */
  async encrypt(plainText) {
    try {
      // Create message from text
      const message = openpgp.message.fromText(plainText);
      
      // Encrypt with password
      const encrypted = await openpgp.encrypt({
        message: message,
        passwords: [this.password],
        armor: false // Binary output
      });
      
      // Convert to hex
      const uint8Array = encrypted.message.packets.write();
      let hexString = '';
      for (let i = 0; i < uint8Array.length; i++) {
        hexString += uint8Array[i].toString(16).padStart(2, '0');
      }
      
      
      return hexString;
    } catch (error) {
      console.error('OpenPGP encryption error:', error);
      throw error;
    }
  }

  /**
   * Decrypts OpenPGP encrypted password
   * @param {string} hexString - Hex-encoded encrypted password
   * @returns {Promise<string>} Decrypted password
   */
  async decrypt(hexString) {
    try {
      // Convert hex to Uint8Array
      const bytes = new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
      
      // Read the encrypted message
      const message = await openpgp.message.read(bytes);
      
      // Decrypt with password
      const decrypted = await openpgp.decrypt({
        message: message,
        passwords: [this.password],
        format: 'utf8'
      });
      
      return decrypted.data;
    } catch (error) {
      console.error('OpenPGP decryption error:', error);
      throw error;
    }
  }

}

// Create and export service instance
const openpgpService = new OpenPGPService();

export default openpgpService;